import { generateMockMatterLienPayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterLien } from "@/lib/data/react-query/matters/matter-lien";
import type { Contact } from "@/lib/types";
import { useCallback } from "react";
import { useCreateMockMatterContactConnection } from "@/hooks/mock-api-calls/useCreateMockMatterContactConnection";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterLien = () => {
  const createLien = useCreateMatterLien();
  const { createMockMatterContactConnection } =
    useCreateMockMatterContactConnection();

  const createMockMatterLien = useCallback(
    async (
      matterId: string,
      lienHolderContact: Contact,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createLien
          .mutateAsync(generateMockMatterLienPayload(matterId, overrides))
          .then(async (lienResponse) => {
            const lienId = lienResponse.data.id;

            if (lienId) {
              await createMockMatterContactConnection(
                lienHolderContact,
                matterId,
                "Lien Holder",
                {
                  lienId,
                },
              );
            }

            return lienResponse;
          }),
      ),
    [createLien, createMockMatterContactConnection],
  );

  return {
    createMockMatterLien,
    mutation: createLien,
  };
};
